module.exports = __webpack_public_path__ + "static/media/wikipedia-w.c0f83952.svg";